import { FC, memo } from 'react'

import { CircularProgress } from 'ui/components'

import { Content, Header } from './components'
import { PageProps } from './types'

import * as SC from './styles'

// This component does not ready for use
export const PageV2: FC<PageProps> = memo((props) => {
  const { isPending, title, subTitle, actions, breadCrumbs, face, footer, children, ...rest } = props

  const renderBoxHeaderAndContent = () => (
    <>
      {(title || subTitle || actions) && <Header title={title} subTitle={subTitle} face={face} actions={actions} />}
      {!!breadCrumbs && <SC.BreadCrumbsWrapper>{breadCrumbs}</SC.BreadCrumbsWrapper>}
      <Content>{children}</Content>
    </>
  )

  return isPending ? (
    <CircularProgress centered />
  ) : (
    <SC.Box {...rest} data-helios-page $widthFooter={!!footer}>
      {footer ? (
        <SC.BoxWithFooterInner>{renderBoxHeaderAndContent()}</SC.BoxWithFooterInner>
      ) : (
        <>{renderBoxHeaderAndContent()}</>
      )}
      {!!footer && <SC.Footer>{footer}</SC.Footer>}
    </SC.Box>
  )
})
